import getTime from '../../../utils/getTime';

export const calculateViewportTime = (viewportEnterTime: number, viewportTime: number): number => {
  return viewportEnterTime ? viewportTime + (getTime() - viewportEnterTime) : viewportTime;
};
